<template>
  <div
    class="p-4 md:p-[50px] lg:p-[100px] grid grid-cols-1 gap-[40px] bg-[#F4F4F4]"
  >
    <div class="flex flex-col gap-4">
      <h1 class="text-[24px] md:text-[32px] lg:text-[36px] font-semibold">
        {{ getLocalized(contentData, "title") }}
      </h1>
      <p class="text-[16px] lg:text-[24px] lg:max-w-[700px]">
        {{ getLocalized(contentData, "description") }}
      </p>
    </div>

    <!-- Render the service-card-component for each combined service -->
    <service-card-component
      v-for="(item, index) in combinedServiceData"
      :key="index"
      :img="item.image_path"
      :title="getLocalized(item, 'name')"
      :detailed="getLocalized(item, 'description')"
      :route="item.url"
    />
  </div>
</template>

<script>
import axios from "axios";
import serviceCardComponent from "./serviceComponent.vue";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";

export default {
  components: { serviceCardComponent },
  computed: {
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  data() {
    return {
      api: process.env.VUE_APP_API_KEY,
      serviceData: [],
      subServiceLink: [],
      combinedServiceData: [], // To store the combined data
      contentData: {},

      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  mounted() {
    this.mainService();
  },

  methods: {
    async mainService() {
      try {
        // Fetch main services
        const responseMainService = await axios.get(
          this.api + "/api/main-services"
        );
        this.serviceData = responseMainService.data.items;
        this.serviceData = this.serviceData
          .map((item) => ({
            ...item,
            image_path: `${this.api}${item.image_path}`,
          }))
          .sort((a, b) => a.display_order - b.display_order);

        // Fetch submenus
        const responseSubService = await axios.get(this.api + "/api/submenus");
        this.subServiceLink = responseSubService.data.items;
        this.subServiceLink = this.subServiceLink
          .filter((item) => item.display_order > 1 && item.display_order <= 6)
          .sort((a, b) => a.display_order - b.display_order);

        // Merge the service data with the corresponding URLs
        this.combinedServiceData = this.serviceData.map((service) => {
          const subService = this.subServiceLink.find(
            (sub) => sub.name_en === service.name_en // Adjust matching criteria as necessary
          );

          // If subservice URL is found, assign it; otherwise, leave as empty or provide a fallback
          return {
            ...service,
            url: subService ? subService.url : "", // Add URL from subServiceLink, fallback if missing
          };
        });

        this.contentData = await fetchContentSection(2);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style></style>
